import { ChangeDetectionStrategy, Component } from "@angular/core";
import { LookerRiskDashboardType } from "../../looker-risk-dashboard-type.enum";
import { HideFilters } from "../../models/analytics-hide-filters.enum";

@Component({
  selector: "app-deletes-tracking-dw",
  templateUrl: "./deletes-tracking-dw.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DeletesTrackingDwComponent {
  filters: string[] = ["Projects"];
  dashboardType = LookerRiskDashboardType.DELETES_TRACKING_DASHBOARD_DW;
  hideFilters = [HideFilters.PROJECT_ID, HideFilters.ORG_ID, HideFilters.USER_ID];
}
